import { render, staticRenderFns } from "./CostiPersonaleListTable.vue?vue&type=template&id=2a6ac2e5&"
import script from "./CostiPersonaleListTable.vue?vue&type=script&lang=js&"
export * from "./CostiPersonaleListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports